export default {
  init() {
    // JavaScript to be fired on the about us page
    window.updateQuantity = function (event, id, add = 1) {
      const it = $(`#${id}`)
      const button = it.siblings('a.add_to_cart_button')
      button.attr('data-quantity', +it.val() + add)
    }

    $(document.body).on('wc_cart_button_updated', function (event, button) {
      button.parents('.modal').hide()
    })
  },
};
